import { render, staticRenderFns } from "./DesignersList.vue?vue&type=template&id=0427f570&scoped=true"
import script from "./DesignersList.vue?vue&type=script&lang=js"
export * from "./DesignersList.vue?vue&type=script&lang=js"
import style0 from "./DesignersList.vue?vue&type=style&index=0&id=0427f570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427f570",
  null
  
)

export default component.exports